<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#' + tab.type"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>

		<v-tabs-items v-model="activeTab" touchless>
			<v-tab-item :value="tabs[0].type">
				<v-container>
					<v-data-table
						:headers="headers"
						:themeInputColor="themeInputColor"
						:items="users['old'].list"
						:loading="fetchingRetailUsers['old']"
					>
						<template v-slot:items="props">
							<tr>
								<td class="text-xs-center px-2">
									{{
										props.item.updatedOn
									}}
								</td>
								<td class="text-xs-center px-2">
									{{ props.item.teamName }}
								</td>
								<td class="text-xs-center px-2">
									{{ props.item.depositBalance }}
								</td>
								<td class="text-xs-center px-2">
									{{
										props.item.phoneNo
											? props.item.phoneNo.toString().slice(2)
											: ""
									}}
								</td>
								<td class="text-xs-center px-2">
									<a
										:href="'tel:' + (props.item.phoneNo || '')"
										>Call</a>
									/
									<a
										@click="messageOnWhatsapp(props.item)"
									>
										Whatsapp
									</a>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-container>
				<v-layout row wrap class="justify-center my-3 px-2 pb-2">
					<div>
						<v-btn
							:color="themeInputColor"
							class="white--text"
							v-if="users['old'].offset"
							@click.stop="
								fetchJeet11RetailUsers({
									type: END,
									new: false
								})
							"
							>Load More</v-btn
						>
					</div>
				</v-layout>
			</v-tab-item>
			<v-tab-item :value="tabs[1].type">
				<v-container>
					<v-data-table
						:headers="headers"
						:themeInputColor="themeInputColor"
						:items="users['new'].list"
						:loading="fetchingRetailUsers['new']"
					>
						<template v-slot:items="props">
							<tr>
								<td class="text-xs-center px-2">
									{{
										props.item.updatedOn
									}}
								</td>
								<td class="text-xs-center px-2">
									{{ props.item.teamName }}
								</td>
								<td class="text-xs-center px-2">
									{{ props.item.depositBalance }}
								</td>
								<td class="text-xs-center px-2">
									{{
										props.item.phoneNo
											? props.item.phoneNo.toString().slice(2)
											: ""
									}}
								</td>
								<td class="text-xs-center px-2">
									<a
										:href="'tel:' + (props.item.phoneNo || '')"
										>Call</a>
									/
									<a
										@click="messageOnWhatsapp(props.item)"
									>
										Whatsapp
									</a>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-container>
				<v-layout row wrap class="justify-center my-3 px-2 pb-2">
					<div>
						<v-btn
							:color="themeInputColor"
							class="white--text"
							v-if="users['new'].offset"
							@click.stop="
								fetchJeet11RetailUsers({
									type: END,
									new: true
								})
							"
							>Load More</v-btn
						>
					</div>
				</v-layout>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { themeInputColor, shareOnWhatsapp } from "@/utils";
import {
	FETCH_JEET11_USERS_BY_RETAILER_ID,
	RESET_JEET11_USERS_BY_RETAILER_ID
} from "@/store/action-types";
import { TOP, END } from "@/store/config";

export default {
	mounted() {
		this.fetchRetailUsers();
	},
	destroyed() {		
		this.resetRetailUsers();
	},
	name: "RetailUsers",
	data() {
		return {
			END,
			TOP,
			fetchingRetailUsers: {
				new: false,
				old: false
			},
			activeTab: "old",
			themeInputColor,
			tabs: [
				{ name: "Old Users", type: "old" },
				{ name: "New Users", type: "new" }
			],
			headers: [
				{
					text: "Updated On",
					value: "updatedOn",
					align: "center",
					sortable: false
				},
				{
					text: "Team Name",
					value: "teamName",
					align: "center",
					sortable: false
				},
				{
					text: "Deposit Balance",
					value: "depositBalance",
					align: "center",
					sortable: false
				},
				{
					text: "Phone No",
					value: "phoneNo",
					align: "center",
					sortable: false
				},
				{
					text: "Contact",
					value: "phoneNo",
					align: "center",
					sortable: false
				}
			],
		};
	},
	methods: {
		fetchRetailUsers() {
			this.fetchJeet11RetailUsers({ type: TOP, new: true });
			this.fetchJeet11RetailUsers({ type: TOP, new: false });
		},
		fetchJeet11RetailUsers(payload) {
			const customersType = payload.new ? "new" : "old";
			payload.retailerId = this.$route.query.id;
			if (!this.fetchingRetailUsers[customersType]) {
				this.fetchingRetailUsers[customersType] = true;
				this.$store
					.dispatch(
						FETCH_JEET11_USERS_BY_RETAILER_ID.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingRetailUsers[customersType] = false;
					});
			}
		},
		resetRetailUsers() {
			this.$store.dispatch(RESET_JEET11_USERS_BY_RETAILER_ID.dispatch, {});
		},
		messageOnWhatsapp(jeet11User) {
			shareOnWhatsapp("", "", jeet11User.phoneNo);
		},
	},
	computed: {
		...mapState({
			users: (state) =>
				state.jeet11.usersByRetailerID.users
		}),
		isNew() {
			return this.tabMetaData.type === "new";
		}
	},
};
</script>

<style scoped>
.white-bg {
	background: #fff;
}
a {
	text-decoration: none;
}
</style>
